import { Component, OnInit, OnDestroy, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { PlatformApp } from '../../../services/app.service';
import * as _ from 'lodash';
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';

@Component({
    selector: 'filter-display',
    templateUrl: './filter-display.component.html'
})

export class FilterDisplayComponent implements OnInit, OnDestroy, OnChanges {
    @Input() filters: string = '';
    @Input() datafields: string = '';
    @Output() onChanged: EventEmitter<any> = new EventEmitter<any>();

    records = [];
    fields = [];
    subscriptions: any = [];
    notifyOptions = PlatformApp.getNotificationOptions();
    constructor(private _NotificationsService: NotificationsService, private _PushNotificationsService: PushNotificationsService) { }

    ngOnInit(): void {
    }

    ngOnDestroy() {
        for (var i = 0; i < this.subscriptions.length; i++) this.subscriptions[i].unsubscribe();
    }

    ngOnChanges(changes) {
        this.updateData();
    }

    private onFilterAdded(records) {
        this.emitOutput(records);
    }

    private updateData() {
        if (this.filters && this.filters !== '[{}]' && this.filters !== '[]' && this.filters !== "")
            this.records = JSON.parse(this.filters);
        else
            this.records = [];

        if (this.datafields && this.datafields !== '[{}]' && this.datafields !== '[]' && this.datafields !== "")
            this.fields = JSON.parse(this.datafields);
        else
            this.fields = [];
    }

    private emitOutput(records) {
        this.onChanged.emit(records);
    }

    private clearFilters() {
        this.notify('success', 'Filters', this.records.length + ' Removed');
        this.records = [];
        this.emitOutput(this.records);
    }

    private deleteFilter(i) {
        let record = this.records[i];
        this.records.splice(i, 1);
        this.notify('success', 'Filter Removed', record.filterfield_label);
        this.emitOutput(this.records);
    }

    private notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/filter-display/filter-display.component.ts